
import { Component, Prop, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";
import UploaderReuploadButton from "@/components/NewFileUploader/NbNewUploader/UploaderReuploadButton.vue";

import IMAGE_ERROR from "@/assets/images/upload-error.svg";
import IMAGE_FILE from "@/assets/images/upload-file.svg";

const IMAGE_PROPS = {
  width: 32,
  height: 32,
};

const BUTTON_PROPS = {
  outline: true,
  small: true,
};

const MESSAGES = {
  title: "The file has some error. \nPlease reupload it",
};

const ERROR_WRONG_FILE_MESSAGE = "wrong file";

@Component({
  components: {
    UploaderReuploadButton,
    UploaderState,
  },
})
export default class FileHasSomeErrorUploaderState extends Vue {
  @Prop() readonly file?;
  @Prop() readonly error?;
  @Prop({ type: Array, default: () => [] }) readonly errors?: string[];

  IMAGE_PROPS = IMAGE_PROPS;
  MESSAGES = MESSAGES;
  BUTTON_PROPS = BUTTON_PROPS;

  openFileSelect() {
    const target = this.$refs.file as HTMLInputElement;

    if (!target) return;

    target?.click();
  }

  reUpload(payload) {
    const target = payload.target as HTMLInputElement;

    const targetFile = target?.files?.[0];

    this.$emit("re-upload", targetFile);
  }

  get imageSrc() {
    return this.error?.message === ERROR_WRONG_FILE_MESSAGE ? IMAGE_FILE : IMAGE_ERROR;
  }

  get errorTitle() {
    return this.error?.preview_error_title ?? this.MESSAGES.title;
  }

  get description() {
    return this.error?.preview_error_description ?? "";
  }
}
